<template>
    <div v-if="showOverlay" class="search-overlay">
        <autocomplete ref="search" 
            :model="query" 
            :search="searchSuggestions" 
            class="position-relative" 
            :placeholder="model.langSearchPlaceholder" 
            :aria-label="model.langSearchPlaceholder" 
            :get-result-value="getSuggestionText" 
            @submit="handleSubmit">
                <template
                    #default="{
                        rootProps,
                        inputProps,
                        inputListeners,
                        resultListProps,
                        resultListListeners,
                        results,
                        resultProps
                    }"
                >
                <div v-bind="rootProps">
                    <custom-input ref="searchInput"
                        :class="[
                            'autocomplete-input'
                        ]"
                        v-bind="inputProps"
                        v-on="inputListeners"
                    ></custom-input>
                    <ul v-bind="resultListProps" role="region" aria-live="polite" aria-atomic="true" v-on="resultListListeners">
                        <li class="suggestions-text">{{ model.suggestionsLabel }}:</li>
                        <li
                            v-for="(result, index) in results"
                            :key="resultProps[index].id"
                            class="autocomplete-result"
                            v-bind="resultProps[index]"
                            >
                            {{ result.text }}
                        </li>
                    </ul>
                </div>
            </template>
        </autocomplete>
        <button class="button" type="submit" @click="submit">{{ model.searchButtonLabel }}</button>
        <button class="unstyled-button" :aria-label="model.closeLabel" @click="hideOverlay">
            <svg class="icon icon-hsy-icon-close-bold"><use xlink:href="#icon-hsy-icon-close-bold"></use></svg>
        </button>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import customInput from './custom-input.vue';

    export default {
        components: {
            "custom-input": customInput
        },
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                query: '',
            }
        },
        computed: mapState({
            showOverlay: state => state.showOverlay
        }),
        watch: {
            showOverlay: function () {
                if (this.showOverlay) {
                    this.$nextTick(function () {
                        this.$refs.searchInput.$el.focus();
                    });
                }
            }
        },
        methods: {
            searchSuggestions(query) {
                this.query = query;
                const url = `${this.model.autoSuggestionsUrl}?query=${encodeURI(this.query)}`
                return new Promise(resolve => {
                    if (this.query.length < 1) {
                        return resolve([])
                    }

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            resolve(data.hits);
                        });
                });
            },
            getSuggestionText(suggestion){
                return (suggestion || {}).text;
            },
            handleSubmit(selectedSuggestion) {
                if (selectedSuggestion) {
                    this.goToPage(selectedSuggestion.url);
                }
                else {
                    window.open(`${this.model.searchPageUrl}?query=` + encodeURI(this.query), "_self");
                }
            },
            hideOverlay() {
                this.$store.commit('hideOverlay');
            },
            goToPage(pageUrl) {
                window.location.href = pageUrl
            },
            submit() {
                window.open(`${this.model.searchPageUrl}?query=` + encodeURI(this.query), "_self");
            }
        }
    }
</script>